var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('parent-card');
import { breakpoints, theme } from '@shapeable/theme';
import { Icons } from '../icons';
import { CellLabel } from '../elements/cell-label';
import { Icon } from '../elements/icon';
import { OutlineNumber } from '../elements/outline-number';
import { EntityLink } from './entity-link';
import { EntityThumbnailImage } from './entity-image';
export var ParentCardDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    display: block;\n  \n    &:hover {\n      filter: brightness(1.1);\n    }\n  "], ["\n    position: relative;\n    display: block;\n  \n    &:hover {\n      filter: brightness(1.1);\n    }\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    background: #969696;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n    padding: ", ";\n    padding-right: ", ";\n    ", "\n  "], ["\n    display: flex;\n    background: #969696;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n    padding: ", ";\n    padding-right: ", ";\n    ", "\n  "])), theme.UNIT(4), theme.UNIT(2), function (_a) {
    var _color = _a._color;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), _color);
  })
});
var NumberAndNameStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    min-height: 35px;\n  "], ["\n    display: flex;\n    align-items: center;\n    min-height: 35px;\n  "])))
});
var OutlineNumberStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-right: 0;\n  "], ["\n    margin-right: 0;\n  "])))
});
var NameStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-family: ", ";\n    font-weight: 400;\n    font-size: 1.2em;\n    color: ", ";\n    margin-left: ", ";\n    padding-right: ", ";\n  "], ["\n    font-family: ", ";\n    font-weight: 400;\n    font-size: 1.2em;\n    color: ", ";\n    margin-left: ", ";\n    padding-right: ", ";\n  "])), theme.FONT('serif'), theme.COLOR('light'), theme.UNIT(2), theme.UNIT(4))
});
var IconStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme.FILL('light'))
});
var ImageStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    color: ", ";\n    margin-bottom: ", ";\n  "], ["\n    color: ", ";\n    margin-bottom: ", ";\n  "])), theme.COLOR('light'), theme.UNIT(2))
});
var InfoStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: styled(EntityLink)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Label: styled(CellLabel)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Info: styled.div.attrs(cls.attr('label'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  NumberAndName: styled.div.attrs(cls.attr('number-and-name'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), NumberAndNameStyles),
  OutlineNumber: styled(OutlineNumber)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), OutlineNumberStyles),
  Name: styled.span.attrs(cls.attr('name'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Icon: styled(Icon)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Image: styled(EntityThumbnailImage)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
export var ParentCard = function ParentCard(props) {
  var className = props.className,
      entity = props.entity,
      description = props.description,
      label = props.label; // treat the description in props separately, because some cards can use a different prop (e.g. trend intro)

  var outlineNumber = entity.outlineNumber,
      name = entity.name,
      color = entity.color;
  var hasDescription = !!description;
  var hasOutlineNumber = !!outlineNumber;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Link, {
    entity: entity
  }, React.createElement(My.Body, {
    _color: color && color.value
  }, React.createElement(My.Info, null, label && React.createElement(My.Label, null, label), React.createElement(My.NumberAndName, null, hasOutlineNumber && React.createElement(My.OutlineNumber, {
    size: "cell",
    color: color
  }, outlineNumber), React.createElement(My.Name, null, name))), React.createElement(My.Icon, {
    size: 28
  }, React.createElement(Icons.ChevronRight, null)))));
};
ParentCard.defaultProps = ParentCardDefaultProps;
ParentCard.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;